<template>
    <InputField
        :value="value"
        placeholder="Search..."
        name="search"
        class="searchField"
        @input="val => $emit('input', val)"
    >
        <template v-slot:icon>
            <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
        </template>
    </InputField>
</template>

<script>
import InputField from '../form/InputField.vue';

export default {
    components: {
        InputField,
    },
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
    },
};
</script>
